document.addEventListener('DOMContentLoaded', () => {
  const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  const expiryBox = document.getElementById('variant-offer-expiry');
  const expiryDateEl = expiryBox?.querySelector('.expiry-date');

  if (variantInput && expiryBox && expiryDateEl) {
    const observer = new MutationObserver(() => updateExpiry(variantInput.value));
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    // Initial run
    updateExpiry(variantInput.value);
  }

  function updateExpiry(variantId) {
    const expiry = expiryBox.getAttribute('data-expiry-' + variantId);
    if (expiry) {
      expiryDateEl.textContent = expiry.replace(/-/g, '.'); // ex: 2026.05.12
      expiryBox.style.display = "flex";
    } else {
      expiryDateEl.textContent = "";
      expiryBox.style.display = "none"; // hide block if no expiry
    }
  }
});

// Script For Quantity limit to the product
(function() {
  const MAX_QTY = 5;
  const BLOCKED_RESPONSE = new Response(JSON.stringify({ blocked: true }), {
    status: 200,
    headers: { "Content-Type": "application/json" }
  });

  // Helpers
  function toInt(v){ const n = parseInt(v,10); return Number.isNaN(n) ? 0 : n; }

  async function getCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      return await res.json();
    } catch (e) {
      return { items: [] };
    }
  }

  function showInlineError(container, msg) {
    if (!container) return;
    let el = container.querySelector('.qty-limit-error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'qty-limit-error';
      el.style.color = '#c0392b';
      el.style.fontSize = '16px';
      el.style.marginTop = '6px';
      el.setAttribute('role', 'alert');
      container.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
  }

  // Track last clicked form for inline message placement
  let lastClickedForm = null;
  document.addEventListener('click', function(e) {
    const btn = e.target && e.target.closest('button, [name="add"], [data-add-to-cart], .add-to-cart, .product-form__cart-submit, [data-cart-submit]');
    if (!btn) return;
    const form = btn.closest('form[action*="/cart/add"], form');
    if (form) lastClickedForm = form;
  }, true);

  // Global product form clamp (all add-to-cart forms)
  function clampProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const qty = form.querySelector('input[name="quantity"], input[type="number"]');
      if (!qty) return;
      qty.setAttribute('max', String(MAX_QTY));
      qty.addEventListener('input', () => {
        let v = toInt(qty.value);
        if (v < 1) v = 1;
        if (v > MAX_QTY) v = MAX_QTY;
        qty.value = String(v);
      });
      form.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-action="increase"], .quantity-button--increase, .quantity-button--plus, .qty-plus, .m-quantity__button[name="plus"]');
        if (!btn) return;
        setTimeout(() => {
          let v = toInt(qty.value);
          if (v > MAX_QTY) qty.value = String(MAX_QTY);
        }, 20);
      });
    });
  }

  // Minimog cart drawer clamp
  function clampCartDrawer() {
    const drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return;

    function updateWidget(widget){
      const input = widget && widget.querySelector('.m-quantity__input');
      const plus = widget && widget.querySelector('.m-quantity__button[name="plus"]');
      const minus = widget && widget.querySelector('.m-quantity__button[name="minus"]');
      if (!input) return;
      let v = toInt(input.value);
      if (v < 1) v = 1;
      if (v > MAX_QTY) v = MAX_QTY;
      input.value = String(v);
      input.setAttribute('max', String(MAX_QTY));
      if (plus) plus.disabled = v >= MAX_QTY;
      if (minus) minus.disabled = v <= 1;
      input.readOnly = v >= MAX_QTY;
    }

    function applyAll(){ drawer.querySelectorAll('m-quantity-input').forEach(updateWidget); }
    applyAll();

    drawer.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest('.m-quantity__button');
      if (!btn) return;
      const widget = btn.closest('m-quantity-input');
      setTimeout(() => updateWidget(widget), 30);
    });
    drawer.addEventListener('input', (e) => {
      const el = e.target;
      if (!(el instanceof HTMLInputElement)) return;
      if (!el.classList.contains('m-quantity__input')) return;
      const widget = el.closest('m-quantity-input');
      updateWidget(widget);
    });

    const observer = new MutationObserver(() => applyAll());
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // Intercept fetch for server-side guard
  const origFetch = window.fetch;
  window.fetch = async function(input, init) {
    try {
      const url = (typeof input === 'string') ? input : input?.url || '';
      const lower = String(url).toLowerCase();
      if (lower.includes('/cart/add') || lower.includes('/cart/change') || lower.includes('/cart/update')) {
        // crude best-effort parse of FormData only
        let variantId = null; let qty = 1; let productId = null;
        if (init?.body instanceof FormData) {
          variantId = init.body.get('id');
          qty = toInt(init.body.get('quantity') || '1') || 1;
          productId = init.body.get('product_id');
        }
        const cart = await getCart();
        const MESSAGE = (window.MinimogSettings && window.MinimogSettings.qty_limit_message) || 'Sorry, you can’t add more than 5 of the same item.';
        // compute future quantity per product (across variants) or per line
        if (productId) {
          let total = 0; cart.items.forEach(it => { if (String(it.product_id) === String(productId)) total += it.quantity; });
          if (total + qty > MAX_QTY) {
            if (lastClickedForm) showInlineError(lastClickedForm, MESSAGE);
            return BLOCKED_RESPONSE;
          }
        } else if (variantId) {
          const ex = cart.items.find(it => String(it.id) === String(variantId) || String(it.variant_id) === String(variantId));
          const current = ex ? ex.quantity : 0;
          if (current + qty > MAX_QTY) {
            if (lastClickedForm) showInlineError(lastClickedForm, MESSAGE);
            return BLOCKED_RESPONSE;
          }
        }
      }
    } catch (_) {}
    return origFetch.apply(this, arguments);
  };

  function onReady(){
    clampProductForms();
    clampCartDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();


// Collapsible Content List Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize collapsible content lists
  const collapsibleContentLists = document.querySelectorAll('.m-collapsible-content-list');
  
  collapsibleContentLists.forEach(function(contentContainer) {
    const accordionHeaders = contentContainer.querySelectorAll('.accordian__header');

    // Open first item by default
    const firstItem = contentContainer.querySelector('.accordian__item');
    if (firstItem) {
      const firstHeader = firstItem.querySelector('.accordian__header');
      const firstContent = firstItem.querySelector('.accordian__content');
      if (firstHeader && firstContent) {
        firstHeader.classList.add('active');
        firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
      }
    }

    // Accordion functionality for each content item (single-open behavior)
    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function() {
        const accordionItem = this.closest('.accordian__item');
        const accordionContent = accordionItem && accordionItem.querySelector('.accordian__content');
        const wasActive = this.classList.contains('active');

        // Close all items within this container
        contentContainer.querySelectorAll('.accordian__header').forEach(function(h) {
          h.classList.remove('active');
          const c = h.closest('.accordian__item') && h.closest('.accordian__item').querySelector('.accordian__content');
          if (c) c.style.maxHeight = '0px';
        });

        // If the clicked one was not active, open it; otherwise leave all closed
        if (!wasActive) {
          this.classList.add('active');
          if (accordionContent) {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
          }
        }
      });
    });
  });
});